<template>
    <article class="page-cabinet-dashboard-dividends">
        <div class="page-cabinet-dashboard-dividends__headline">
            <div class="page-cabinet-dashboard-dividends__headline-title">
                Дивиденды
            </div>
        </div>
        <div class="page-cabinet-dashboard-dividends__graph">
            <ui-card-base with-border>
                <div class="page-cabinet-dashboard-dividends__graph-container">
                    <ui-graph
                        v-bind:data="seriesData"
                        v-bind:categories="categoriesData"
                        v-on:hoverTooltip="onHoverTooltip"
                        v-bind:customTooltip="customTooltip"
                    />
                </div>
                <div class="page-cabinet-dashboard-dividends__graph-button _left" v-if="hasNextPage">
                    <ui-icon-button :size="48" v-on:click="() => { ++page }">
                        <icon name="arrow-left" width="16px" height="16px" color="#6737AF"/>
                    </ui-icon-button>
                </div>
                <div
                    class="page-cabinet-dashboard-dividends__graph-button _right"
                    v-if="page > 1"
                    >
                    <ui-icon-button :size="48" v-on:click="() => { page > 1 ? --page : page = 1 }">
                        <icon name="arrow-right" width="16px" height="16px" color="#6737AF"/>
                    </ui-icon-button>
                </div>
            </ui-card-base>

            <div class="page-cabinet-dashboard-dividends__graph-back-forward">
                <page-cabinet-back-forward
                    v-bind:has-prev-button="page > 1"
                    v-bind:has-next-button="hasNextPage"
                    v-on:on-back="page > 1 ? --page : page = 1"
                    v-on:on-forward="page++"
                />
            </div>

            <transition name="fade">
                <div class="page-cabinet-dashboard-dividends__graph-loader"
                    v-if="isLoading"
                    >
                    <ui-loader
                        v-bind:fixed="50"
                        v-bind:centered="true"
                    />
                </div>
            </transition>
        </div>
    </article>
</template>

<script>
import moment from 'moment';
import { mainClient } from '~/network';
import utils from '~/utils';

export default {
    name: 'page-cabinet-dashboard-dividends',
    data: function() {
        return {
            activeIndex: 0,
            series: [],
            categories: [],
            data: [0, 0, 0, 0],
            isLoading: false,
            page: 1,
            tooltipIndex: -1,
            screenWidth: window.innerWidth,
        };
    },
    computed: {
        user() {
            return this.$store.getters['users/user'];
        },
        /* categories() {
            if (!this.activeMode?.params) return [];
            const year = this.activeMode.params.yearShort;
            return [ `1кв'${year}`, `2кв'${year}`, `3кв'${year}`, `4кв'${year}` ];
        }, */
        activeMode() {
            return this.modes[this.activeIndex];
        },
        modes() {
            const result = [];
            if (this.user === null || this.user === 'guest') {
                result.push({
                    title: moment().format('YYYY'),
                    params: {
                        year: moment().format('YYYY'),
                        yearShort: moment().format('YY'),
                    },
                });
            } else {
                const currentYear = new Date().getFullYear();
                const registrationYear = this.user.dateRegistered.getFullYear();
                const yearsDiff = currentYear - registrationYear;
                for (let i = 0; i < yearsDiff + 1; i++) {
                    result.push({
                        title: registrationYear + i,
                        params: {
                            year: registrationYear + i,
                            yearShort: moment((registrationYear + i).toString()).format('YY'),
                        },
                    });
                }
                this.setActiveIndex(yearsDiff);
            }
            return result;
        },
        pages() {
            return Math.ceil(this.data.length / this.perPage);
        },
        perPage() {
            return this.isSmallScreen ? 4 : 12;
        },
        startIndex() {
            return (this.page - 1) * this.perPage;
        },
        hasNextPage() {
            return this.startIndex + this.perPage < this.data.length;
        },
        seriesData() {
            return this.sliceOnPage(this.data);
        },
        categoriesData() {
            return this.sliceOnPage(this.categories);
        },
        customTooltip() {
            if (this.tooltipIndex >= 0) {
                const tooltipData = this.series?.filter((s) => !!this.sliceOnPage(s.data)?.[this.tooltipIndex])?.map((s) => {
                    return {
                        name: s.name,
                        acronym: s.acronym,
                        data: this.sliceOnPage(s.data)[this.tooltipIndex],
                    };
                });
                const items = tooltipData.map((d) => `<div>${d.acronym} - ${utils.formats.formatNumberWithSpaces(d.data.toFixed(0))}</div>`);
                return `<div class="" style="background-color: #27242D; color: white; border: 0; padding: 8px;">${items.join('')}</div>`;
            }
            return null;
        },
        isSmallScreen() {
            return this.screenWidth < 1023;
        },
    },
    methods: {
        sliceOnPage(arr) {
            return arr?.slice(-(this.page * this.perPage), arr.length - (this.page - 1) * this.perPage) || [];
        },
        onHoverTooltip(index) {
            this.tooltipIndex = index;
        },
        async getData() {
            if (!this.activeMode?.params) return;
            this.isLoading = true;
            const { data, error, status } = await mainClient.users.requests.getDashboardDividends({
                // points_count: 4,
                // year: this.activeMode.params.year,
            });
            if (error) {
                console.error(error, status);
            } else {
                this.series = data?.series ?? [];
                this.categories = data?.categories ?? [];
                const dataLength = this.categories.length;
                const result = new Array(dataLength).fill(0);
                for (let i = 0; i < dataLength; i++) {
                    for (const obj of this.series) {
                        result[i] += obj.data[i];
                    }
                    result[i] = result[i].toFixed(0);
                }
                this.data = result;
            }
            this.isLoading = false;
        },
        setActiveIndex(index) {
            this.activeIndex = index;
        },
        checkScreenWidth() {
            this.screenWidth = window.innerWidth;
        },
    },
    watch: {
        activeIndex: {
            handler() {
                this.getData();
            },
            immediate: true,
        },
        user() {
            this.getData();
        },
    },
    mounted() {
        window.addEventListener('resize', this.checkScreenWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenWidth);
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-dashboard-dividends {
    margin-bottom: 40px;
    &__headline {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        width: 100%;
        padding: 0 16px;
        &-title {
            .typography-heading();

            flex: 0 0 auto;
            padding-right: 24px;
            padding-bottom: 8px;
        }
        &-switchers {
            .typography-body();

            flex: 0 1 auto;
            display: flex;
            align-items: baseline;
            justify-content: flex-end;
            flex-wrap: wrap;
            margin: 0 -12px;
            &-item {
                padding: 8px 12px;

                color: @color-gray-main;

                cursor: pointer;

                transition: color @duration-fast ease-in-out;
                &._active {
                    color: @color-gray-darker;
                }
            }
        }
    }
    &__graph {
        position: relative;
        &-container {
            width: 100%;
            height: 200px;
        }
        &-button {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            &._left {
                left: -24px;
            }
            &._right {
                right: -24px;
            }
        }
        @media @media-md-down {
            &-button {
                display: none;
            }
        }
        &-back-forward {
            display: none;
            margin-top: 16px;
        }
        @media @media-md-down {
            &-back-forward {
                display: block;
            }
        }
        &-loader {
            .transition-fade();

            position: absolute;
            top: 5px;
            right: 5px;
            bottom: 5px;
            left: 5px;
            z-index: 1;

            display: flex;
            align-items: center;
            justify-content: center;

            background-color: fade(@color-gray-lightest, 75%);
        }
    }
}
</style>
